import { createTheme } from '@material-ui/core/styles';
import { breakpointsValues } from './breakpoints';
import typography from './typography';
import grid from './grid';

const theme = createTheme({
  breakpoints: breakpointsValues,
  typography,
  spacing: grid.spacing,
});

export default theme;
